import { render, staticRenderFns } from "./FcStaticImage.vue?vue&type=template&id=26709d08&scoped=true&"
import script from "./FcStaticImage.vue?vue&type=script&lang=ts&"
export * from "./FcStaticImage.vue?vue&type=script&lang=ts&"
import style0 from "./FcStaticImage.vue?vue&type=style&index=0&id=26709d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26709d08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
